import { useEffect } from 'react';
import locationMap from '../images/location-map.png';
import '../styles/Location.scss';

function Location(props: { title: string }) {
  useEffect(() => {
    document.title = props.title;
  });
  return (
    <div className="location-container">
      <div className="location-page">
        <h1>DO YOU EVER WONDER</h1>
        <h1>WHAT YOU WILL DO</h1>
        <h1>IN THE FUTURE</h1>
        <h1>DIGITAL WORLD?</h1>
        <h2>Alnair is expecting you at Pavilion 1, E128</h2>
        <div className="ticket-description">
          <p>To know your future, show your ticket at the booth.</p>
          <p>Your destiny is in your hands.</p>
        </div>
        <div className="softserve-logo">
          <span>soft</span>
          <span className="bold">serve</span>
        </div>
      </div>
      <img alt="map" src={locationMap}></img>
    </div>
  );
}

export default Location;
